// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { GuidedWorkflowsMenuModule } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/guided-workflows-menu.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { QuickflowsMenuModule } from 'QuickflowsApp/ts/features/quickflows-menu/quickflows-menu.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SideMenuModule {
}
SideMenuModule.ɵfac = function SideMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuModule)(); };
SideMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SideMenuModule });
SideMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, QuickflowsMenuModule, GuidedWorkflowsMenuModule, IconModule, TooltipModule] });
